/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useSpinnersContext } from "../../contexts/spinnersContext";

/* Components */
import Spinner from "../spinners/buttonSpinner";

/* Styles */
import styles from "./styles.js"

const UCInput = props => {
  const { value, icon, className = "", placeholder = "", onChange, onClick, inputClassName, removableChip, disabled, autocomplete, name, spinner, clearButton, showClearButton, inputRef, ariaLabel, tabIndex, onFocus } = props;

  const theme = useTheme();
  const classes = styles({ theme });
  const spinners = useSpinnersContext();

  return (
    <div className={`${classes.inputWrapper} ${className}`} tabIndex={tabIndex}>
      {
        spinners[spinner?.name] ? 
          <Spinner size={spinner['size']} color={spinner['color']} customClass={classes.spinner}/>
         : icon && <span className={classes.icon}>{ icon }</span>

      }
      { removableChip ? removableChip : (
        <input className={`${classes.input} ${inputClassName}`} placeholder={placeholder} onChange={onChange} onClick={onClick} disabled={disabled} autoComplete={autocomplete} name={name} ref={inputRef} value={value} aria-label={ariaLabel} onFocus={onFocus}/>
      ) }
      {
        showClearButton && clearButton 
      }
    </div>
  )
}

export default UCInput;
